export default __webpack_public_path__ + "static/media/product-15.2109a8c5.jpg";